import { fork } from 'redux-saga/effects'

import appModalSaga from './appModal/saga'
import authSaga from './auth/saga'
import indicatorsSaga from './indicators/saga'
import intelApiSaga from './intelApi/saga'
import nautilusApiSaga from './nautilusApi/saga'
import adminSaga from './admin/saga'
import upgradeSaga from './upgrade/saga'

export default function * rootSaga() {
  yield fork(appModalSaga)
  yield fork(authSaga)
  yield fork(indicatorsSaga)
  yield fork(intelApiSaga)
  yield fork(nautilusApiSaga)
  yield fork(adminSaga)
  yield fork(upgradeSaga)
}
